import { costAnalysisService, costComparisonService } from '../../services';

interface IConfig {
  getMultiAccountsData: (params: any) => Promise<any>;
  getCategoryOptions: (params: any) => Promise<any>;

  downloadMultiAccountReport: (params: any) => Promise<any>;
}

export const config: IConfig = {
  getMultiAccountsData: (params: any) =>
    costComparisonService.getMultiAccountsData(params),
  getCategoryOptions: (params: any) =>
    costAnalysisService.getCategoryList(params),
  downloadMultiAccountReport: (params: any) =>
    costComparisonService.downloadMultiAccountReport(params),
};

export const AWS_SERVICES_SHORTHAND: Record<string, string> = {
  'AWS Service Catalog': 'Service Catalog',
  'Amazon Simple Email Service': 'SES',
  'AWS Systems Manager': 'Systems Manager',
  'AWS Glue': 'Glue',
  'AWS Key Management Service': 'KMS',
  'Amazon Elastic File System': 'EFS',
  'Amazon DynamoDB': 'DynamoDB',
  'Amazon Virtual Private Cloud': 'VPC',
  'AWS CloudFormation': 'CloudFormation',
  'Amazon Simple Queue Service': 'SQS',
  'Amazon Keyspaces (for Apache Cassandra)': 'Keyspaces',
  'Amazon Relational Database Service': 'RDS',
  'Amazon OpenSearch Service': 'OpenSearch',
  'AWS Lambda': 'Lambda',
  'AWS Amplify': 'Amplify',
  'AWS WAF': 'WAF',
  'Amazon Route 53': 'Route 53',
  'Amazon ElastiCache': 'ElastiCache',
  'Amazon Simple Storage Service': 'S3',
  'AWS Config': 'Config',
  'AWS Data Transfer': 'Data Transfer',
  'Amazon API Gateway': 'API Gateway',
  'AWS CodePipeline': 'CodePipeline',
  CodeBuild: 'CodeBuild',
  'AWS CloudTrail': 'CloudTrail',
  'Elastic Load Balancing': 'ELB',
  'Amazon SimpleDB': 'SimpleDB',
  'Amazon Elastic Container Service': 'ECS',
  'AWS Backup': 'Backup',
  'AWS Cost Explorer': 'Cost Explorer',
  'Amazon Simple Notification Service': 'SNS',
  'AWS Secrets Manager': 'Secrets Manager',
  'Amazon EC2 Container Registry (ECR)': 'ECR',
  'Amazon Elastic Container Service for Kubernetes': 'EKS',
  'Amazon Elastic Compute Cloud': 'EC2',
  'CloudWatch Events': 'CW Events',
  AmazonCloudWatch: 'CloudWatch',
  'Amazon CloudFront': 'CloudFront',
  'AWS X-Ray': 'X-Ray',
  'Amazon Inspector': 'Inspector',
  'Amazon GuardDuty': 'GuardDuty',
  'AWS Security Hub': 'Security Hub',
};
